import React, { useEffect, useState } from "react";
import { blog } from "../data/blog";
import { Link } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ReactMarkdown from "react-markdown";
const Blog = ({ slice }) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    async function fetchArticles() {
      const fetchedArticles = await Promise.all(
        blog.map(async (article) => {
          const response = await fetch(article.article);
          const markdownContent = await response.text();

          return { ...article, markdownContent };
        })
      );
      setArticles(fetchedArticles);
    }

    fetchArticles();
  }, []);
  return (
    <div className=" max-screen py-20">
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold text-center mb-4 capitalize">
          Latest Article from our blog
        </h1>
        <p className="text-primary font-semibold uppercase">news & blog</p>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-8 ">
        {articles.slice(0, slice).map((item, index) => {
          return <SingleArticle key={index} {...item} />;
        })}
      </div>
      <div className="flex-c mt-12 lg:mt-16 z-10 relative">
        <Link
          to="/blog"
          className="text-primary hover:text-secondary underline text-xl font-semibold underline-offset-4">
          Discover All
        </Link>
      </div>
    </div>
  );
};

const SingleArticle = ({ title, tag, intro, img, date, markdownContent }) => {
  return (
    <div className="bg-white rounded shadow hover:shadow-lg transition-all duration-300">
      <div>
        <img src={img} alt={title} className="aspect-video object-cover" />
      </div>
      <div className="px-6 py-10  flex flex-col justify-between  ">
        <div className="  flex flex-col gap-1">
          <span className="text-primary font-medium capitalize">{tag}</span>
          <h3 className="text-2xl text-neutral-2 font-medium ">
            <a href={`/blog/${title}`}>{title}</a>
          </h3>

          <p className="text-neutral-5 font-light text-sm">{date}</p>
        </div>

        {/* <ReactMarkdown children={markdownContent} /> */}
        <div className="flex flex-col gap-4">
          {" "}
          <p className="text-base text-neutral-3 mt-4 article-preview ">
            {intro}
          </p>
          <Link
            to={`/blog/${title}`}
            className="flex w-fit items-end  text-primary hover:text-secondary hover:border-b-2 border-secondary text-sm font-semibold ">
            Read More <KeyboardDoubleArrowRightIcon sx={{ fontSize: "1rem" }} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export { Blog, SingleArticle };
